import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useSettingsLdFlags = createFlagsHook<typeof import('./flags.json')>()
